/* Shown while the app is still asking the server who you are. It says what
   it is waiting for rather than spinning silently. */
export function Splash({ label = "Loading" }) {
  return (
    <div className="splash">
      <div className="splash-mark">
        <h1>War Room</h1>
        <span className="sub">INSOMNIACS &middot; 10 PLAYGROUNDS</span>
      </div>
      <p className="splash-label mono">{label}…</p>
    </div>
  );
}
